var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"搜索","loading":_vm.loading}},[(!_vm.loading)?[_c('dmbc-resource-list',{attrs:{"load":_vm.handleDataLoad}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }